import React from "react";
import { apiCaller } from "@utils";
import { TableCheckbox } from "../";

const ValidateFoodItem = ({ row, cell }) => {
    const handleChangeValidate = (e) => {
        const params = {
            "action_type": "validate_food_item",
            "food_id": row?.food_id
        };
        //Truyền true hàm apiCaller để sử dụng api makansafe
        apiCaller(`/api/iddsi/functional/`, "POST", params, true)
            .then(res => {
                if (res?.status === 200) {
                    console.log("success....");
                } else {
                    console.error("Error occurred:", res?.statusText);
                }
            })
            .catch(error => {
                console.error("Error occurred:", error);
            })
            .finally(() => {
                console.log("finally....");
            });
    };

    return (
        <div className="d-flex justify-content-center align-items-center" style={{ height: "100%" }}>
            <TableCheckbox
                checked={cell}
                onChange={handleChangeValidate}
                id={`Reviewed_${row?.food_id}`}
            />
        </div>
    );
};

export default ValidateFoodItem;